export const AD_PLAYER_ID = 'ihr-ad-player';
